import { apiClient } from './client';
import type { HealthResponse, HealthHeadersResponse } from './types';

// ── Health checks ────────────────────────────────────────────────────────────

/**
 * Verificar que el backend está activo.
 *
 * GET /health/
 */
export function healthCheck() {
  return apiClient.get<HealthResponse>('/health/', undefined, true);
}

/**
 * Obtener cabeceras proxy y contexto de la solicitud (diagnóstico de proxy inverso).
 *
 * GET /health/headers
 */
export function healthHeaders() {
  return apiClient.get<HealthHeadersResponse>(
    '/health/headers',
    undefined,
    true,
  );
}
